import React, { useState, useEffect, useContext } from "react";
import { AppContext } from "../../AppContextProvider";
import UseraddressJsonStorage from "../../utils/useraddress/useraddressJsonStorage";
import { AvalancheContext } from "../../avalanche/AvalancheProvider";
import { WalletProviderContext } from "../../walletprovider/WalletProvider";
import ProfileJsonStorage from "../../utils/storage/profileJsonStorage";
import { MDBDatatable, MDBTable, MDBTableHead, MDBTableBody, MDBIcon, MDBSelect } from "mdb-react-ui-kit";
import DeleteModal from "../../modals/DeleteModal";
import filter_alt from "../../assets/media/icons/filter-alt.svg";
import delete_icon from "../../assets/media/icons/delete.svg";
import cross_invert from "../../assets/media/icons/cross-invert.svg";
import tag from "../../assets/media/icons/tag.svg";
import cross_invert_color from "../../assets/media/icons/cross-invert-color.svg";
import tag_color from "../../assets/media/icons/tag-color.svg";

export default function WhiteUserTable(props) {
  const context = useContext(AppContext);
  const avalancheContext = useContext(AvalancheContext);
  const useraddressJsonStorage = UseraddressJsonStorage.create(avalancheContext);
  const walletContext = useContext(WalletProviderContext);
  const profileJsonStorage = ProfileJsonStorage.create(avalancheContext, walletContext);
  const [openModal, setOpenModal] = useState(false);
  const [isMultiselectRegistered, setIsMultiselectRegistered] = useState(false);
  const [isMultiselectFeedback, setIsMultiselectFeedback] = useState(false);
  const [isMultiselectRole, setIsMultiselectRole] = useState(false);
  const [registeredFilterArray, setRegisteredFilterArray] = useState(["Yes", "No"]);
  const [feedbackFilterArray, setFeedbackFilterArray] = useState(["Yes", "No"]);
  const [roleFilterArray, setRoleFilterArray] = useState(["admin", "extern", "intern"]);
  const [walletId, setWalletId] = useState();
  const [useraddressArray, setUseraddressArray] = useState([]);

  const actionData = {
    columns: [
      { label: "Nr.", field: "number" },
      { label: <div style={{ textAlign: "left", paddingLeft: 0 }}>{"Wallet address"}</div>, field: "wallet" },
      { label: <div style={{ textAlign: "center", paddingLeft: 0 }}>{"Registered"}</div>, field: "registered" },
      { label: <div style={{ textAlign: "center", paddingLeft: 0 }}>{"Feedback"}</div>, field: "feedback" },
      { label: <div style={{ textAlign: "center", paddingLeft: 0 }}>{"Role"}</div>, field: "role" },
      { label: "Delete", field: "delete", sort: false },
    ],
    rows: props.useraddressArray
      .filter((k) => registeredFilterArray.includes(k.useraddress.registered ? "Yes" : "No"))
      .filter((k) => roleFilterArray.includes(k.useraddress.role))
      .filter((k) =>
        feedbackFilterArray.includes(
          props.feedbackArray
            .map((k) => {
              return k.address;
            })
            .includes(k.useraddress.address)
            ? "Yes"
            : "No",
        ),
      )
      .map((k, n) => {
        return {
          number: n + 1,
          wallet: k.useraddress.address,
          role: k.useraddress.role !== "" ? k.useraddress.role : "admin",
          registered: k.useraddress.registered ? "Yes" : "No",
          feedback: props.feedbackArray
            .map((k) => {
              return k.address;
            })
            .includes(k.useraddress.address)
            ? "Yes"
            : "No",
        };
      })
      .map((row, i) => {
        return {
          ...row,
          number: <div style={{ textAlign: "center" }}>{row.number}</div>,
          delete: (
            <div style={{ textAlign: "center" }}>
              <button
                className="button subtle medium"
                onClick={() => {
                  setWalletId(row.wallet);
                  setOpenModal(true);
                }}
              >
                <MDBIcon far icon="trash-alt" />
              </button>
            </div>
          ),
          role: <div style={{ textAlign: "center" }}>{row.role}</div>,
          feedback: <div style={{ textAlign: "center" }}>{row.feedback}</div>,
          registered: <div style={{ textAlign: "center" }}>{row.registered}</div>,
        };
      }),
  };

  return (
    <>
      <div className="actions-div whitelist ms-2">
        <MDBSelect
          data={[{ text: "Yes" }, { text: "No" }]}
          multiple
          clearBtn={isMultiselectRegistered}
          onValueChange={(val) =>
            setRegisteredFilterArray(
              val.length > 0
                ? val.map((k) => {
                    setIsMultiselectRegistered(true);
                    return k.text;
                  })
                : [{ text: "Yes" }, { text: "No" }].map((k) => {
                    setIsMultiselectRegistered(false);
                    return k.text;
                  }),
            )
          }
          label={
            <div className="multiselect-div">
              <img src={filter_alt} alt="filter" />
              <span>Registered</span>
            </div>
          }
        />
        {window.innerWidth > 992 && <div className="spacer" />}
        <MDBSelect
          data={[{ text: "Yes" }, { text: "No" }]}
          multiple
          clearBtn={isMultiselectFeedback}
          onValueChange={(val) =>
            setFeedbackFilterArray(
              val.length > 0
                ? val.map((k) => {
                    setIsMultiselectFeedback(true);
                    return k.text;
                  })
                : [{ text: "Yes" }, { text: "No" }].map((k) => {
                    setIsMultiselectFeedback(false);
                    return k.text;
                  }),
            )
          }
          label={
            <div className="multiselect-div">
              <img src={filter_alt} alt="filter" />
              <span>Feedback</span>
            </div>
          }
        />
        {window.innerWidth > 992 && <div className="spacer" />}
        <MDBSelect
          data={[{ text: "admin" }, { text: "extern" }, { text: "intern" }]}
          multiple
          clearBtn={isMultiselectRole}
          onValueChange={(val) =>
            setRoleFilterArray(
              val.length > 0
                ? val.map((k) => {
                    setIsMultiselectRole(true);
                    return k.text;
                  })
                : [{ text: "admin" }, { text: "extern" }, { text: "intern" }].map((k) => {
                    setIsMultiselectRole(false);
                    return k.text;
                  }),
            )
          }
          label={
            <div className="multiselect-div">
              <img src={filter_alt} alt="filter" />
              <span>Role</span>
            </div>
          }
        />
        {window.innerWidth > 992 && <div className="spacer" />}
        {isMultiselectRegistered && (
          <>
            <div className="filter-div">
              <span className="filter-title">Filter Registered:</span>
              {registeredFilterArray.map((k, n) => {
                return (
                  <div className="tags-div-2" key={n}>
                    <img src={tag_color} alt="tag" />
                    <span>{k}</span>
                    <img src={cross_invert_color} alt="cross-invert" />
                  </div>
                );
              })}
            </div>
            {window.innerWidth > 992 && <div className="spacer" />}
          </>
        )}
        {isMultiselectFeedback && (
          <>
            <div className="filter-div">
              <span className="filter-title">Filter Feedback:</span>
              {feedbackFilterArray.map((k, n) => {
                return (
                  <div className="tags-div-2" key={n}>
                    <img src={tag_color} alt="tag" />
                    <span>{k}</span>
                    <img src={cross_invert_color} alt="cross-invert" />
                  </div>
                );
              })}
            </div>
            {window.innerWidth > 992 && <div className="spacer" />}
          </>
        )}
        {isMultiselectRole && (
          <>
            <div className="filter-div">
              <span className="filter-title">Filter Role:</span>
              {roleFilterArray.map((k, n) => {
                return (
                  <div className="tags-div-2" key={n}>
                    <img src={tag_color} alt="tag" />
                    <span>{k}</span>
                    <img src={cross_invert_color} alt="cross-invert" />
                  </div>
                );
              })}
            </div>
            {window.innerWidth > 992 && <div className="spacer" />}
          </>
        )}
      </div>
      <div className="tbody-div">
        <MDBDatatable hover search data={actionData} />
        {openModal && (
          <DeleteModal
            visible={openModal}
            handleClose={() => setOpenModal(false)}
            onDeleteFeedback={() => {
              props.deleteUserFromList(walletId);
              setOpenModal(false);
            }}
          />
        )}
      </div>
    </>
  );
}
